import { ReactNode } from "react";
// The case that uses this transforms the current path, locale included
// eslint-disable-next-line no-restricted-imports
import { Navigate, useLocation } from "react-router";
import { Forward } from "@components/shared/Forward";
import { useGlobalContext } from "@utils/GlobalContext";

interface RegionProviderProps {
  children: ReactNode;
}

export const RegionMapper: React.FC<RegionProviderProps> = ({ children }) => {
  const location = useLocation();
  const { isRegionLocked, locale, supportedLocales } = useGlobalContext();

  const isNotOnProperRegion = !location.pathname.startsWith(
    `/${locale.toLocaleLowerCase()}`
  );

  if (isNotOnProperRegion) {
    const isOnBadCaseRegion = location.pathname
      .toLocaleLowerCase()
      .startsWith(`/${locale.toLocaleLowerCase()}`);

    if (isOnBadCaseRegion) {
      return (
        <Navigate
          to={`${location.pathname.toLocaleLowerCase()}${location.search}${
            location.hash
          }`}
          replace
        />
      );
    }

    // 0th index is "" because these strings start with /
    const [, firstPathSegment] = location.pathname.split("/");
    if (
      supportedLocales
        .map((l) => l.toLocaleLowerCase())
        .includes(firstPathSegment)
    ) {
      return (
        <Forward
          replace
          to={`/${
            // slice(2) because this always has a leading slash, so the first element is ""
            location.pathname.split("/").slice(2).join("/")
          }`}
        />
      );
    }

    return (
      <Forward
        replace
        to={`${location.pathname}${location.search}${location.hash}`}
      />
    );
  }

  if (
    isRegionLocked &&
    !["/get-connected", "/article/terms-and-conditions"].some((limitedRoute) =>
      location.pathname.endsWith(limitedRoute)
    )
  ) {
    return <Forward replace to="/get-connected" />;
  }

  return children;
};
